/**
 * @file attention-columns.tsx
 * @description Колонки «Требуют внимания» для `ResponsiveList` (phase19.31,
 * разбор A §1): заказ · проблема (янтарная или красная, «N дн») · с какого
 * события · перевозчик словом · трек моноширинным.
 *
 * На телефоне: «Z-… · 4 дн» / «Без движения» / «СДЭК · трек · с какого
 * события». Строка целиком — ссылка в заказ.
 */

import { AttentionProblem } from "./AttentionProblem";
import type { ListColumn } from "../../ui/responsive-list-types";
import { TwoLineCell } from "../../ui/TwoLineCell";
import { ATTENTION_TONE_CLASS, type AttentionRow } from "../../../lib/order-attention-rows";
import { cn } from "@/lib/utils";

export const ATTENTION_COLUMNS: ListColumn<AttentionRow>[] = [
  {
    key: "order",
    header: "Заказ",
    width: "w-[152px]",
    cell: (row) => <span className="type-body whitespace-nowrap font-medium tabular-nums">{row.orderNumber}</span>,
    compact: "title",
    compactCell: (row) => <span className="tabular-nums">{row.orderNumber}</span>,
  },
  {
    key: "problem",
    header: "Проблема",
    width: "w-[220px]",
    cell: (row) => <TwoLineCell primary={<AttentionProblem row={row} />} secondary={`стоит ${row.elapsed}`} />,
    compact: "subtitle",
    compactCell: (row) => <AttentionProblem row={row} />,
  },
  {
    key: "elapsed",
    header: "Сколько",
    compactOnly: true,
    cell: (row) => <span className={cn("tabular-nums", ATTENTION_TONE_CLASS[row.tone])}>{row.elapsed}</span>,
    compact: "trailing",
  },
  {
    key: "event",
    header: "С какого события",
    cell: (row) => <TwoLineCell primary={row.event} secondary={`с ${row.since}`} />,
    compact: "meta",
    compactCell: (row) => row.event,
  },
  {
    key: "carrier",
    header: "Перевозчик",
    width: "w-[160px]",
    cell: (row) => row.carrier ?? <span className="text-on-surface-variant">—</span>,
    compact: "meta",
    compactCell: (row) => row.carrier,
  },
  {
    key: "track",
    header: "Трек",
    width: "w-[180px]",
    cell: (row) =>
      row.track ? (
        <span className="font-mono">{row.track}</span>
      ) : (
        <span className="text-on-surface-variant">{row.carrier ? "трека нет" : "—"}</span>
      ),
    fold: { into: "carrier", cell: (row) => (row.track ? <span className="font-mono">{row.track}</span> : null) },
    compact: "meta",
    compactCell: (row) => (row.track ? <span className="font-mono">{row.track}</span> : null),
  },
];
